const $ = require('jquery');

/*FADE-IN EFFEKT*/
function isElementInViewport(element) {
    var rect = element.getBoundingClientRect();
    return (
        rect.top < window.innerHeight && rect.bottom >= 0
    );
}
  var elements = document.querySelectorAll(".reveal");
    
  function callbackFunc() {
    for (var i = 0; i < elements.length; i++) {
        if (isElementInViewport(elements[i])) {
            elements[i].classList.add("reveal-show");
        }
    }

    for (var i = 0; i < $('.stage').length; i++) {
        if (isElementInViewport($('.stage')[i])) {
            $('.animated-line')[i].classList.add("animate-line");
        }
    }
}

    
  window.addEventListener("load", callbackFunc);
  window.addEventListener("scroll", callbackFunc);



// WEBPACK FOOTER //
// ./wp/wp-content/themes/brockmeyer-chisel/src/scripts/additional/waypoints.js